import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';
import Empty from '../components/Empty.jsx';
import { loadingContent } from '../components/EmptyStates.jsx';

const Survey = React.lazy(() => import('../pages/survey'));
const SurveyResponse = React.lazy(() => import('../pages/survey-response'));
const SurveySubmitEmail = React.lazy(
  () => import('../pages/survey-submit-email')
);

export const surveyRoutes = () => (
  <>
    <Route
      path={ROUTES.SURVEY}
      element={
        <React.Suspense
          fallback={<Empty simplified content={loadingContent} />}
        >
          <Survey />
        </React.Suspense>
      }
    />
    <Route
      path={ROUTES.SURVEY_RESPONSE}
      element={
        <React.Suspense
          fallback={<Empty simplified content={loadingContent} />}
        >
          <SurveyResponse />
        </React.Suspense>
      }
    />
    <Route
      path={ROUTES.SURVEY_SUBMIT_EMAIL}
      element={
        <React.Suspense
          fallback={<Empty simplified content={loadingContent} />}
        >
          <SurveySubmitEmail />
        </React.Suspense>
      }
    />
  </>
);
